import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { MOCK_ROUTES } from 'src/app/components/reports/reports.constants';
import { BUTTON_TYPES } from 'src/app/components/shared/modal/components/modal-frame/modal-frame.constants';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';

import { map, mergeMap, take } from 'rxjs';
import {
  CODReconcile,
  CODReconcileRequest,
} from 'src/app/core/models/reports/cod-reconcile.model';
import { CodsReportsService } from 'src/app/core/services/reports/cod/cod-reports.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { ReconcilePopupComponent } from './reconcile-popup/reconcile-popup.component';
import { CONSTS, ReconcileFormGroup } from './reconcile.constants';

@Component({
  selector: 'app-reconcile',
  templateUrl: './reconcile.component.html',
  styleUrls: ['./reconcile.component.scss'],
  standalone: false,
})
export class ReconcileComponent implements OnInit {
  readonly destroy = inject(DestroyRef);
  readonly input: ReconcileFormGroup = inject(MAT_DIALOG_DATA);
  private userService = inject(UserService);
  private fb: FormBuilder = inject(FormBuilder);
  private dialogRef: MatDialogRef<ReconcileComponent> = inject(
    MatDialogRef<ReconcileComponent>,
  );
  private dialog: MatDialog = inject(MatDialog);
  private codReconcileReportService: CodsReportsService =
    inject(CodsReportsService);
  private commonUtils: CommonUtils = inject(CommonUtils);

  readonly CONSTS = CONSTS;
  readonly IMAGES = IMAGE_SRC;
  readonly BUTTON_TYPES = BUTTON_TYPES;

  reconcileForm!: FormGroup;

  routes = MOCK_ROUTES;
  reconcileData: CODReconcile[] = [];
  locationCode = '';

  ngOnInit(): void {
    this.reconcileForm = this.fb.group({
      routes: [MOCK_ROUTES[0]],
    });

    this.getRouteList();
  }

  onExit() {
    this.commonUtils.openExitModal(this.reconcileForm.dirty);
  }

  /**
   * To get route list
   *
   * @memberof ReconcileReportComponent
   */
  getRouteList() {
    this.userService
      .getCurrentUser$()
      .pipe(
        take(1),
        mergeMap((user) => {
          return this.codReconcileReportService
            .getReconcileRoutes(user?.location)
            .pipe(
              take(1),
              map((data) => {
                this.routes = data.response.CODReconcileRoutes.map(
                  ({ route }) => {
                    return {
                      label: route,
                      value: route,
                    };
                  },
                ).sort((a, b) => a.label.localeCompare(b.label));
                this.routes.unshift({
                  label: $localize`All`,
                  value: 'All',
                });
                this.reconcileForm
                  .get('routes')
                  ?.setValue(this.routes[0].value);
              }),
            );
        }),
      )
      .subscribe();
  }

  getReport() {
    this.userService
      .getCurrentUser$()
      .pipe(
        take(1),
        mergeMap((user) => {
          const request: CODReconcileRequest = {
            locationcode: user?.location,
            loop: this.reconcileForm.get('routes')?.value,
          };

          return this.codReconcileReportService.getCODReconcile(request).pipe(
            take(1),
            map((data) => {
              const codReconcileReport = data.response.codReconcile;

              if (codReconcileReport?.length) {
                this.reconcileData = data.response.codReconcile;
                this.dialog.open(ReconcilePopupComponent, {
                  minWidth: '25rem',
                  disableClose: true,
                  autoFocus: false,
                  data: this.reconcileData,
                });
              } else {
                this.commonUtils.updateBannerType(
                  BANNER_TYPE.NO_DATA_AVAILABLE,
                );
              }

              this.dialogRef.close();
            }),
          );
        }),
      )
      .subscribe();
  }
}
